import { z } from "zod";
import { stripSearchParams, type SearchMiddleware } from "@tanstack/react-router";
import {
  defaultPageSearch,
  optionalCalendarDay,
  optionalPage,
  optionalSearch,
  poolContextSearchSchema,
} from "./shared";

const assetSortSchema = z.enum([
  "createdAt:asc",
  "createdAt:desc",
  "date:asc",
  "date:desc",
  "updatedAt:asc",
  "updatedAt:desc",
]);

export const assetOverviewSearchDefaults = {
  ...defaultPageSearch,
  sort: "createdAt:desc" as const,
};

export const assetOverviewSearchSchema = poolContextSearchSchema.extend({
  dateFrom: optionalCalendarDay,
  dateTo: optionalCalendarDay,
  updatedAtFrom: optionalCalendarDay,
  updatedAtTo: optionalCalendarDay,
  ownedByPool: optionalSearch(z.boolean()),
  sort: optionalSearch(assetSortSchema),
  page: optionalPage,
});

export type AssetOverviewSearch = z.infer<typeof assetOverviewSearchSchema>;

export const assetOverviewSearchMiddlewares: SearchMiddleware<AssetOverviewSearch>[] = [
  stripSearchParams(assetOverviewSearchDefaults) as SearchMiddleware<AssetOverviewSearch>,
];
